define.alias("shared/utils/escape-html", "calendar/utils/escape-html");